import React ,{Suspense, lazy}from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import AuthRoute from "./AuthRoute";
import ScrollToTop from './ScrollTop'; // Adjust path as necessary
import ProtectedRoute from "./ProtectedRoute";
import MainLayout from "../Layouts/MainLayout/MainLayout";

function DevSeed() {
    localStorage.setItem('id', '3');
    localStorage.setItem('token', 'devtoken');
    return <Navigate to="/dev-test-reports" replace />;
}


// const ResetPasswordPage = lazy(() => import('../pages/ForgotPassword/ResetPassword'));
// const SetNewPasswordPage = lazy(() => import('../pages/SetNewPassword'));
const LoginPage = lazy(() => import('../pages/Login/Login'));


// const Dashboard = lazy(() => import('../pages/Home/Dashboard'));
const AssetSearch = lazy(() => import('../pages/AssetSearch/AssetSearch'));
const AssetDetail = lazy(() => import('../pages/AssetSearch/AssetDetail'));
const AssetUpload = lazy(() => import('../pages/AssetUpload/AssetUpload'));
const RegistrationForm = lazy(() => import('../pages/Registration/Registration'));
const Dashboard = lazy(() => import('../pages/Users/Dashboard'));

const VerifyEmailForm = lazy(() => import('../pages/Verification/Verification'));
const ManageUsers = lazy(() => import('../pages/Users/ManageUsers'));

const ManageBuHeads = lazy(() => import('../pages/BuHeads/ManageBuHeads'));
const UploadUser = lazy(() => import('../pages/Users/UploadUser'));

const NewUser = lazy(() => import('../pages/Users/NewUser'));

const EditUser = lazy(() => import('../pages/Users/EditUser'));


const ManageAssets = lazy(() => import('../pages/AssetManage/AssetManage'));
const ManageTags = lazy(() => import('../pages/Tags/ManageTags'));

const AssetEdit = lazy(() => import('../pages/AssetUpload/AssetEdit'));

const MyAccount = lazy(() => import('../pages/MyAccount/MyAccount'));

const AssetReports = lazy(() => import( '../pages/AssetManage/AssetReports'));


const ForgotPassword = lazy(() => import( '../pages/ForgotPassword/ForgotPassword'));
const SetNewPassword = lazy(() => import( '../pages/ForgotPassword/SetPassword'));



const AppRoutes = () => {
    return (
        <Router>
            <ScrollToTop />
            <Suspense fallback={<div>Loading...</div>}>
            <Routes>
                
            <Route path="/" element={<AuthRoute />}>
                    <Route path="/" element={<LoginPage />} />
                </Route>
                <Route path="/login" element={<AuthRoute />}>
                    <Route path="/login" element={<LoginPage />} />
                </Route>

                <Route path="/register" element={<AuthRoute />}>
                    <Route path="/register" element={<RegistrationForm />} />
                </Route>

                <Route exact path="/email/verification/:id" element={<AuthRoute />}>
                    <Route exact path="/email/verification/:id" element={<VerifyEmailForm />} />
                </Route>

                <Route path="/forgotpassword" element={<AuthRoute />}>
                    <Route path="/forgotpassword" element={<ForgotPassword />} />
                </Route>
                <Route path="/set-new-password/:resetkey" element={<AuthRoute />}>
                    <Route path="/set-new-password/:resetkey" element={<SetNewPassword />} />
                </Route>

                {/* All authenticated routes share one persistent ProtectedRoute + MainLayout
                    instance, so the Header/Menus never unmount/remount on navigation. */}
                <Route path="/dev-seed" element={<DevSeed />} />
                <Route path="/dev-test-reports" element={<MainLayout />}>
                    <Route path="/dev-test-reports" element={<AssetReports/>} />
                </Route>
                <Route element={<ProtectedRoute />}>
                    <Route element={<MainLayout />}>
                        <Route path="/home" element={<Dashboard/>} />
                        <Route path="/myaccount" element={<MyAccount/>} />
                        <Route path="/admin/dashboard" element={<Dashboard/>} />
                        <Route path="/asset/search" element={<AssetSearch/>} />
                        <Route path="/asset/manage" element={<ManageAssets/>} />
                        <Route path="/tags/manage" element={<ManageTags/>} />
                        <Route path="/asset/reports" element={<AssetReports/>} />
                        <Route path="/asset/edit/:assetId" element={<AssetEdit/>} />
                        <Route path="/users/manage" element={<ManageUsers/>} />
                        <Route path="/manage/buheads" element={<ManageBuHeads/>} />
                        <Route path="/users/upload" element={<UploadUser/>} />
                        <Route path="/users/add" element={<NewUser/>} />
                        <Route path="/users/edit/:userId" element={<EditUser/>} />
                        <Route path="/asset/:assetId" element={<AssetDetail/>} />
                        <Route path="/asset/upload" element={<AssetUpload/>} />
                        <Route path="*" element={<div>404 Not found Page</div>} />
                    </Route>
                </Route>




                {/* <Route path="/" element={isAuthenticated ? <Navigate to="/home" replace /> : <LoginPage />} />
                <Route path="/login" element={isAuthenticated ? <Navigate to="/home" replace /> : <LoginPage />} />
                <Route path="/forgot-password" element={<ResetPasswordPage />} />
                <Route path="/set-new-password/:resetkey" element={<SetNewPasswordPage />} />
                <Route path="/home1" element={<Dashboard/>} />
                <Route path="/home" element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" replace />} /> */}

                {/* <Route path="*" element={<div>404 Not found Page</div>} /> */}
            </Routes>
            </Suspense>
        </Router>
    );
};

export default AppRoutes;
